import { render, staticRenderFns } from "./OptionalExtras.vue?vue&type=template&id=d1e6fd24"
import script from "./OptionalExtras.vue?vue&type=script&lang=js"
export * from "./OptionalExtras.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports